module.exports = __webpack_public_path__ + "img/组 469@2x.9b7d9962.png";